import type { ReactNode } from "react";
import "../Planner/planner.css";

/** Discreet inline validation copy — shown after a gated CTA click or beside a field. */
export function ModalValHint({
  message,
  tone = "nudge"
}: {
  message: string | null | undefined;
  /** `nudge` = amber guidance; `error` = failed action / server fault */
  tone?: "nudge" | "error";
}) {
  if (!message) return null;
  return (
    <p className={`fgp-modal-valhint fgp-modal-valhint--${tone}`} role="alert">
      {message}
    </p>
  );
}

/** Muted primary button that still accepts clicks to surface validation feedback. */
export function modalGateBtnClass(canProceed: boolean, busy = false): string {
  return canProceed && !busy ? "" : " fgp-btn--gate";
}

export function ModalFootVal({ children }: { children: ReactNode }) {
  return <span className="fgp-modal-footval">{children}</span>;
}
